import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';

import * as APIM from '@common/utils/dist/models/api-messages.js';
import * as PL2 from '@common/utils/dist/models/models-pl2.js';
import {KeyUtilsPL2 as KU} from '@common/utils/dist/utils/key-utils-pl2.js';
import {UtilsPL2 as U} from '@common/utils/dist/utils/utils-pl2.js';
import {ScopeUtils as SU} from '@utils/scope-utils';

import {EventAPIService} from '@services/event-api.service';
import {CopyEventInput} from '@services/events/copy-events';
import {EntryStore} from '@stores/entry.store';
import {ServiceDecorator} from './service-decorator';

@Injectable()
export class CopyEventInterceptorDecorator
  implements EventAPIService, ServiceDecorator<EventAPIService>
{
  private _service: EventAPIService;

  constructor(private entryStore: EntryStore) {}

  setService(service: EventAPIService): void {
    this._service = service;
  }

  sendEvent(input: CopyEventInput): Observable<string | void> {
    if (U.isEmpty(this._service)) {
      throw new Error('[CopyEventInterceptorDecorator]service not initialized');
    }
    if (input.delayed) {
      const cpParams = input.c[0] as APIM.VersionToSCCopy;
      const nextLGI =
        SU.getMaxLGI(
          KU.stringFromKey({mId: cpParams.aMId, sK: cpParams.aSK}),
          this.entryStore.state(),
        ) + 1;

      const cr: Partial<APIM.EntryCreateRequest> = {
        c: cpParams.m.map((m, i) => {
          const lGI =
            (m.uEs[0] as PL2.LabReportUserEntry)?.lGI ??
            (nextLGI > 0 ? nextLGI : i);
          return {
            e: {
              t: PL2.EntryType.StudentCopy,
              lGI: lGI,
              sMId: m.vMId || cpParams.dMId,
              sSK: m.vSK || cpParams.dSK,
            },
            c: m.uEs.map((uE) => ({e: uE})),
          };
        }),
        mId: cpParams.aMId,
        pSK: cpParams.aSK,
      };
      this.entryStore.create(cr, true);
      return of(void 0);
    } else {
      return this._service.sendEvent(input);
    }
  }
}
